<template>
  <span
    :class="svgClass"
    :style="iconStyle"
    aria-hidden="true"
    v-on="$listeners"
  />
</template>

<script>
// doc: https://panjiachen.github.io/vue-element-admin-site/feature/component/svg-icon.html#usage
import { isExternal } from '@/utils/validate'

const localIcons = require.context('../../icons/svg', false, /\.svg$/)
const iconUrls = localIcons.keys().reduce((icons, path) => {
  const name = path.replace(/^\.\//, '').replace(/\.svg$/, '')
  const icon = localIcons(path)
  icons[name] = icon.default || icon
  return icons
}, {})

export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    isExternal() {
      return isExternal(this.iconClass)
    },
    iconUrl() {
      return this.isExternal ? this.iconClass : iconUrls[this.iconClass]
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
    iconStyle() {
      if (!this.iconUrl) {
        return {}
      }

      const maskImage = `url("${this.iconUrl}")`
      return {
        maskImage,
        WebkitMaskImage: maskImage
      }
    }
  }
}
</script>

<style scoped>
.svg-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  background-color: currentColor;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  overflow: hidden;
}
</style>
